<template>
    <div class="col-12">
        <transition name="fade" mode="out-in">
            <div class="row" v-if="!loading" key="mapa-butacas" id="mapa-butacas">
                <div class="col-12 mb-2 p-0 d-md-flex d-block justify-content-between">
                    <h3>Seleccione las butacas para asignarles descuentos:</h3>
                </div>
                <div class="lightgray-content col-12 p-2">
                    <LeafletComponent
                        :plazasSeleccionadas="butacasSeleccionadas"
                        :svgRendered="svgRendered"
                        :originalColor="originalColor"
                        @isPanning="(e) => isPanning = e"
                    />
                </div>
                <div class="col-12 p-0 pt-3" v-if="butacasSeleccionadas.length > 0">
                    <b-card>
                        <PorPlazas
                            :plazas="butacasSeleccionadas"
                            :recinto_id="recinto_id"
                            :key="reloadComponent"
                            :recargar="true"
                            :seleccionarTodas="seleccionarTodas"
                            @recargar="reload()"
                            @getButacas="recargar"
                        />
                    </b-card>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12 text-center" style="height: 400px">
                    <LoaderComponent/>
                </div>
            </div>                            
        </transition>
    </div>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import PorPlazas from './PorPlazas';
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: ['recinto_id', 'plazas'],
        data() {
            return {
                loading: false,
                svg: null,
                butacasSeleccionadas: [],
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red',
                seleccionadaColor: '#8CA9D9',
                descuentoVisibilidadColor: 'purple',
                svgRendered: null,
                isPanning: null,
                reloadComponent: 1,
                butacas: null,
                sectores: null,
                seleccionarTodas: false
            }   
        },
        methods: {
            getSvg() {
                this.loading = true;
                const params = {
                    recinto_id: this.recinto_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                    .then(res => {
                        this.svg = res.data.svg;
                        this.renderLeafletSvg(this.svg);
                    }).finally(() => this.loading = false)
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        if (plaza.visibilidad_reducida) {
                            const title = this.getButacaName(plaza);
                            this.drawPopover(circle, plaza, title);
                            if(plaza.descuento_visibilidad_reducida){
                                circle.setAttribute('fill', this.descuentoVisibilidadColor);
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                circle.setAttribute('fill', this.descuentoVisibilidadColor);
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickButaca(plaza.id);
                                        }
                                    }, 150);
                                });
                            } else {
                                circle.setAttribute('fill', this.originalColor);
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                circle.setAttribute('fill', this.originalColor);
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickButaca(plaza.id);
                                        }
                                    }, 150);
                                });
                            }

                        } else {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.noDisponibleColor);
                            circle.style.cursor = 'not-allowed';
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            clickButaca(butaca_id) {
                let butacaSeleccionada = this.plazas.find(butacas => butacas.id == butaca_id);
                if (butacaSeleccionada) {
                    butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                    if (butacaSeleccionada.seleccionada) {
                        this.butacasSeleccionadas.push(butacaSeleccionada)
                    } else {
                        const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                    
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                }

                this.reload();
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    const nombre = this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.sesionIdRuta, clave => this.$te(clave)));
                    name += '<span class="text-danger"> ' + nombre + '</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            drawPopover(circle, butaca, title = null) {
                if (this.load_panzoom) {
                    let content = '';

                    if(butaca.descuento_visibilidad_reducida !== null) {
                        content += '<div><strong>Descuento: </strong>' + butaca.descuento_visibilidad_reducida + '%</div>';
                    }

                    const popoverOptions = {
                        title: title,
                        content: content,
                        trigger: 'hover',
                        html: true
                    }

                    new Popover(circle, popoverOptions);
                }
            },
            reload() {
                this.reloadComponent += 1;
            },
            recargar() {
                this.$emit('recargar')
            }
        },
        computed: {
            sesionIdRuta() {
                return this.$route?.params?.sesion_id ?? null;
            },
            load_panzoom() {
                let load_panzoom = true;
                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }

                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            }
        },
        created() {
            this.getSvg();
            this.plazas.forEach(butaca => {
                butaca.seleccionada = false;
                butaca.changed = false;
            });
        },
        components: {
            LeafletComponent,
            PorPlazas
        }
    }
</script>